var render = function () {
  var _vm$summary$totalCoun, _vm$summary$totalCoun2;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('list-widget', {
    attrs: {
      "title": "검색결과"
    }
  }, [_c('b', {
    staticClass: "mr-1"
  }, [_vm._v(" " + _vm._s((_vm$summary$totalCoun = _vm.summary.totalCount) === null || _vm$summary$totalCoun === void 0 ? void 0 : (_vm$summary$totalCoun2 = _vm$summary$totalCoun.format) === null || _vm$summary$totalCoun2 === void 0 ? void 0 : _vm$summary$totalCoun2.call(_vm$summary$totalCoun)) + " ")]), _vm._v(" 건 ")]);
}
var staticRenderFns = []

export { render, staticRenderFns }